var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-form__section --edit"},[_c(_vm.sectionComponent,_vm._g({ref:"field",tag:"component",attrs:{"section":_vm.section,"section-index":_vm.sectionIndex}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }